import { CircularProgress, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useCallback, useEffect, useState } from "react";
import { ADCUBE_ENTITY } from "../../../../common/const/ADcubeEntity";
import { ApiService } from "../../../../service/ApiService";
import { ChangeUserPermissionModal } from "../modal/ChangeUserPermissionListModal";
import { ChangeUserRoleModal } from "../modal/ChangeUserRoleModal";
import { UserPermissionCard } from "./UserPermissionCard";


export const UsersPermission = ({ selectedEntity }) => {
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState(null);

  const [editRoleModalOpen, setEditRoleModalOpen] = useState(false);
  const [editPermissionModalOpen, setEditPermissionModalOpen] = useState(false);
  const [editUserModal, setEditUserModal] = useState(null);

  const openEditPermissionModal = (type, user) => {
    setEditUserModal(user);
    if (type === ADCUBE_ENTITY.PROJECT) {
      setEditPermissionModalOpen(true);
    } else {
      setEditRoleModalOpen(true);
    }
  };

  const loadUserListApi = useCallback((type, id) => {
    if (type === "company") {
      setLoading(true);
      ApiService.getUsersByCompany(id)
        .then((response) => {
          setUserList(response);
        })
        .catch(() => {
          setUserList(null);
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (type === "advertiser") {
      setLoading(true);
      ApiService.getUsersByAdvertiser(selectedEntity.company_id, id)
        .then((response) => {
          setUserList(response);
        })
        .catch(() => {
          setUserList(null);
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (type === "project") {
      setLoading(true);
      ApiService.getUsersByProject(selectedEntity.company_id, selectedEntity.advertiser_id, id)
        .then((response) => {
          setUserList(response);
        })
        .catch(() => {
          setUserList(null);
        })
        .finally(() => {
          setLoading(false);
        });
    }

  }, []);

  useEffect(() => {
    loadUserListApi(selectedEntity.type, selectedEntity.id);
  }, [selectedEntity.type, selectedEntity.id, loadUserListApi]);

  return (
    <>
      <Box sx={{ padding: "0 1rem" }}>
        {loading ?
          <CircularProgress />
          : userList ?
            <Box>
              {userList ? (
                userList.map((user) => (
                  <UserPermissionCard
                    user={user}
                    type={selectedEntity.type}
                    key={user.user_id}
                    openEditPermissionModal={openEditPermissionModal}
                  />
                ))
              ) : (
                <Typography>Lista utenti vuota.</Typography>
              )}
            </Box>
            : <Typography>Non riesco a caricare la lista utenti</Typography>
        }
      </Box>
      {editUserModal && editPermissionModalOpen ?
        <ChangeUserPermissionModal
          user={editUserModal}
          open={editPermissionModalOpen}
          projectId={selectedEntity.id}
          onClose={(reload = false) => {
            setEditUserModal(null);
            setEditPermissionModalOpen(false);
            if (reload) {
              loadUserListApi(selectedEntity.type, selectedEntity.id);
            }
          }}
        />
        : ""}
      {editUserModal && editRoleModalOpen ? (
        <ChangeUserRoleModal
          user={editUserModal}
          open={editRoleModalOpen}
          entityType={selectedEntity.type}
          entityId={selectedEntity.id}
          onClose={(reload = false) => {
            setEditUserModal(null);
            setEditRoleModalOpen(false);
            if (reload) {
              loadUserListApi(selectedEntity.type, selectedEntity.id);
            }
          }}
        />
      ) : ""
      }
    </>
  );
};
